<template>
  <div class="animated fadeIn">
      <b-row>
          <b-col sm="12">
              <b-card  header-tag="header" footer-tag="footer">
                <div slot="header">
              <strong>Vehicle Details New</strong>
              <div class="card-header-actions">
                <router-link to="/addvehicleInfoNew">
                  <button
                    class="btn btn-sm btn-primary mr-4 btn-pill"
                    v-on:click="useradd()"
                    type="button" :disabled="isReadOnly"
                  >
                    <i class="fa fa-plus"></i> Add New
                  </button>
                </router-link>
<!--   
                <button
                  class="btn btn-sm btn-primary ml-4"
                  v-on:click="refresh()"
                  type="button"
                >
                  <i class="fa fa-refresh"></i>
                </button> -->
                 <b-button variant="primary" size="sm" @click="openApprovePopup">
                  Vehicle Onboarding Approval
                </b-button> &nbsp;
                 <b-button variant="primary" size="sm" @click="openApprovePopupFreight">
                  Vehicle Freight Charges	Approval
                </b-button>
              </div>
            </div>
                  <b-row>
                      <b-col md="12">
                          <div>
                              <ul class="nav nav-tabs nav-justified">
                                  <li class="nav-item">
                                      <a @click="activeTab = 0"  class="nav-link " :class="{'active' : isActiveTab(0)}">Pending</a>
                                  </li>
                                  <li class="nav-item">
                                      <a @click="activeTab = 1"  class="nav-link " :class="{'active' : isActiveTab(1)}">Freight Pending</a>
                                  </li>
                                  <li class="nav-item">
                                      <a @click="activeTab = 2"  class="nav-link " :class="{'active' : isActiveTab(2)}">Registered</a>
                                  </li>
                                  <li class="nav-item">
                                      <a @click="activeTab = 3"  class="nav-link " :class="{'active' : isActiveTab(3)}">Rejected</a>
                                  </li>
                                  
                              </ul>
                          </div>
                      </b-col> 

                      <b-col md="12">
                          <div class="tab-panel" v-if="isActiveTab(0)">
                            <pendingIncident :HideAnyAction="HideAnyAction" :vehicleidDetails="vehicleidDetails"></pendingIncident>
                          </div>
                           <div class="tab-panel" v-if="isActiveTab(1)">
                                <freightPending :HideAnyAction="HideAnyAction" :vehicleidDetails="vehicleidDetails"></freightPending>
                          </div>
                          <div class="tab-panel" v-if="isActiveTab(2)">
                            <registeredIncident :HideAnyAction="HideAnyAction" :vehicleidDetails="vehicleidDetails"></registeredIncident>
                          </div>
                  
                          <div class="tab-panel" v-if="isActiveTab(3)">
                                <rejectedIncident :HideAnyAction="HideAnyAction" :vehicleidDetails="vehicleidDetails"></rejectedIncident>
                          </div>

                         
                      </b-col>
                  </b-row>
              </b-card>
          </b-col>
      </b-row>
            <!-- show Approve Popup Popup Modal -->
            <b-modal v-model="showApprovePopup" :title="modalTitle">
              <div id="listloader" v-if="loader">
                  <div class="listloader"></div>
                  <br/>
                  <span class="loading" style="color:#fff;">Loading...</span>
                </div>
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Approval Level</th>
                    <th>Email(s)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Level 1</td>
                    <td>{{ approvalDatal1Email }}</td>
                  </tr>
                  <tr>
                    <td>Level 2</td>
                    <td>{{ approvalDatal2Email }}</td>
                  </tr>
                  <tr>
                    <td>Level 3</td>
                    <td>{{ approvalDatal3Email }}</td>
                  </tr>
                </tbody>
              </table>
              <template #modal-footer >
                <b-button variant="secondary" @click="showApprovePopup = false">Close</b-button>
              </template>
            </b-modal>

  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import pendingIncident from '../components/vehicleMaster/pendingIncident.vue'
import registeredIncident from '../components/vehicleMaster/registeredIncident.vue'
import rejectedIncident from '../components/vehicleMaster/rejectedIncident.vue'
import freightPending from '../components/vehicleMaster/freightPending.vue'
export default {
  data() {
      return {
          activeTab: 0,
          pendingIncident,
          registeredIncident,
          rejectedIncident,
          freightPending,
          accessBody:[],
          isReadOnly:false,
          showApprovePopup: false,
          approvalDatal1Email: "",
          approvalDatal2Email: "",
          approvalDatal3Email: "",
          modalTitle: "",
          HideAnyAction:'',
          vehicleidDetails:'',
          isActive:''
      }
  },
  components : {
          pendingIncident,
          registeredIncident,
          rejectedIncident,
          freightPending,
  },

  created: function() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.userType = userInfo.user_type;
      this.user_id = userInfo.sysusermasterid;
      this.accessBody = userInfo.body;
      this.ischeckbodyvalidation();

    // const vehicleid = this.$route.query.vehicleDetails;
    const vehicleid = this.$route.query.vehicleDetails 
    ? JSON.parse(this.$route.query.vehicleDetails) 
    : null;
    if (vehicleid) {
      this.vehicleidDetails = vehicleid.vehicle_id;
    }
   
    this.HideAnyAction = this.$route.query.HideAnyAction;

    console.log("HideAnyAction===================",this.HideAnyAction)
    if (vehicleid && vehicleid.approver_status) {
      if (vehicleid.approver_status=="Pending" || vehicleid.approver_status=='pending') {
        this.activeTab=0; 
        this.isActive = this.activeTab;
        this.isActiveTab(0);
      } 
      else if (vehicleid.approver_status=="freight_pending"){     
        this.activeTab=1; 
        this.isActive = this.activeTab;
        this.isActiveTab(1);
      }
      else if (vehicleid.approver_status=="approved"){
        this.activeTab=2; 
        this.isActive = this.activeTab;
        this.isActiveTab(2);
      }
      else if (vehicleid.approver_status=="rejected"){
        this.activeTab=3; 
        this.isActive = this.activeTab;
        this.isActiveTab(3);
      }
      else {
        this.activeTab=0; 
        this.isActive = this.activeTab;
        this.isActiveTab(0);
      }
    } else {
      this.activeTab=0; 
      this.isActive = this.activeTab;
      this.isActiveTab(0);
    }

    },

  methods: {
   getSystemUserByModule(module) {
      this.loader = true;
      const obj = {
        module: module,
        approverUser:'No'
      };

      this.$http
        .post(`${CONSTANTS.MISREPORT_API_URL}/getSystemUserByModule`, obj)
        .then((result) => {
          this.loader=false;
            if (result.body.returnstatus === "Successful") {
              const updatedDate = "2024-11-18";
             // Initialize a single approvalData object             
              var approvalOptions = result.body.returnvalue;
              this.approvalDatal1Email="";
              this.approvalDatal2Email= "";
              this.approvalDatal3Email= "";
              // Process the returnvalue to populate the single approvalData object
              approvalOptions.forEach(({ sysemailid, approval_action_filtered }) => {
                approval_action_filtered.forEach(({ level }) => {
                  if (level === "l1") {
                    this.approvalDatal1Email += this.approvalDatal1Email
                      ? `, ${sysemailid}`
                      : sysemailid;
                  } else if (level === "l2") {
                    this.approvalDatal2Email += this.approvalDatal2Email
                      ? `, ${sysemailid}`
                      : sysemailid;
                  } else if (level === "l3") {
                    this.approvalDatal3Email += this.approvalDatal3Email
                      ? `, ${sysemailid}`
                      : sysemailid;
                  }
                });
              });
             console.log(this.approvalDatal1Email);
            } else {
              this.approvalData = [];
            }
         }).catch((ex) => {
          console.log("error-----", ex);
        }).finally(() => {
          this.loader = false; // Stop loader when request completes
        });
    },

    openApprovePopup() {
          this.modalTitle = "Vehicle Onboarding Approval Level(Pending Tab)";
          this.showApprovePopup = true;
          this.getSystemUserByModule('vehicle_onboarding');
    },
     openApprovePopupFreight() {
          this.modalTitle = "Vehicle Freight Charges Approval (Freight Pending)";
          this.showApprovePopup = true;
          this.getSystemUserByModule('vehicle_freight_charges');
    },

    ischeckbodyvalidation(){
            for (let i = 0; i < this.accessBody.length; i++) {
                const element = this.accessBody[i];
            
                // if (element.title=='Transporter Master' && element.isReadonly==true && this.route_id=='normal') {
                //   this.isReadOnly=true
                // }
            if (element.child) {
                for (let j = 0; j < element.child.length; j++) {
                const k = element.child[j];
                if (k.title=='Transporter Master' && k.isReadonly==true) {
                    this.isReadOnly=true
                }
                }
            }
            }
            console.log(" this.isReadOnly", this.isReadOnly)
        },
      isActiveTab(id)
      {

      if (this.activeTab!=this.isActive) {
        this.HideAnyAction='No';
        this.vehicleidDetails ='';
      }
      return this.activeTab === id
      },
      useradd: function() {
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
      },
  }
}
</script>
<style scoped>
  .nav-link {
    background: #66635BAD !important;
    border-radius: 10px !important;
    margin-bottom: 20px;
  }
  .nav-link.active {
    background-color: #66635BAD !important;
    background: #00BDF0 !important;
    margin-bottom: 20px;
}
</style>